import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { editPartnerplanOverviewPage } from 'actions/partnerPlanAdminOverviewForm'
import PartnerPlanAdminOverviewDisplayForm from 'views/PartnerPlans/PartnerPlanAdminOverviewDisplayForm'

class PartnerPlanAdminOverviewForm extends Component {
  static propTypes = {
    currentUser: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    modals: PropTypes.object.isRequired,
    partnerPlanAdmin: PropTypes.object.isRequired,
    partnerPlanOverviewForm: PropTypes.object,
  }

  static defaultProps = {
    id: 'partnerPlanOverviewForm',
    partnerPlanOverviewForm: null,
    currentUser: null,
  }

  _submit = (data) => {
    const formData = {
      employee_id: this.props.currentUser.EmployeeId,
      formurl: (data.formurl ? data.formurl : ''),
      guidanceurl: (data.guidanceurl ? data.guidanceurl : ''),
      id: (data.ID ? data.ID : ''),
      year: (data.year ? data.year : ''),
      planstage: '',
      status: '',
      pagebody: '',
      sidebar: '',
      loginname: '', // loginname is stored on the webapi server session
    }
    if (data.year) {
      this.props.dispatch(editPartnerplanOverviewPage(formData, this.props.id))
    }
  }

  render() {
    const {
      modals, hide, forms, id, partnerPlanAdmin, partnerPlanOverviewForm,
    } = this.props
    return (
      <PartnerPlanAdminOverviewDisplayForm
        dispatch={this.props.dispatch}
        forms={forms}
        handleSubmit={this._submit}
        hide={hide}
        id={id}
        modals={modals}
        partnerPlanAdmin={partnerPlanAdmin}
        partnerPlanOverviewForm={partnerPlanOverviewForm}
        title="Update Partner plan overview detail"
      />
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  modals: state.modals,
  forms: state.forms,
  partnerPlanAdmin: state.partnerPlanAdmin,
  partnerPlanOverviewForm: state.partnerPlanOverviewForm,
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PartnerPlanAdminOverviewForm))



// WEBPACK FOOTER //
// ./src/containers/PartnerPlanAdminOverviewForm.js